function e(n, a) {
  return n != null && a in Object(n);
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseHasIn.js
// module id = 1471
// module chunks = 67